export default [
  { id: 0, label: 'ALL', ids: [] },
  { id: 1, name: 'pending', label: 'PENDING', ids: [1, 2] },
  { id: 3, name: 'accepted', label: 'ACCEPTED', ids: [3] },
  { id: 4, name: 'rejected', label: 'RETURNED', ids: [4] },
  { id: 5, name: 'processing', label: 'PROCESSING', ids: [5, 6, 7, 8, 9, 10] },
  { id: 11, name: 'paid', label: 'PAID', ids: [11] },
  { id: 13, name: 're_submitted', label: 'Re-Submitted', ids: [13] },
];
